// Code generated by protoc-gen-ts_proto_ipc_plugin. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto_internal_plugin  v0.1.20
//   protoc               v6.30.2
// source: services/security/user_profile.proto

/* eslint-disable */
import { Injectable } from "@angular/core";
import { GrpcWebErrrHandlingImpl } from "src/app/shared/services/grpc-client";
import { EmptyRequest, EmptyResponse } from "../../common/messages/messages";
import { GetAllProfilesResponse, GetUserProfileResponse, UpdateUserProfileRequest, UserProfile } from "./user_profile";

import { UserProfileServiceClientImpl } from "./user_profile";

@Injectable({ providedIn: "root" })
export class UserProfileServiceSpa {
  constructor(private _rpc: GrpcWebErrrHandlingImpl) {}
  async getAllProfiles(request: EmptyRequest): Promise<GetAllProfilesResponse> {
    const client = new UserProfileServiceClientImpl(this._rpc);
    return await client.getAllProfiles(request);
  }
  async getByToken(request: EmptyRequest): Promise<GetUserProfileResponse> {
    const client = new UserProfileServiceClientImpl(this._rpc);
    return await client.getByToken(request);
  }
  async updateUserProfile(request: UpdateUserProfileRequest): Promise<EmptyResponse> {
    const client = new UserProfileServiceClientImpl(this._rpc);
    return await client.updateUserProfile(request);
  }
  async addUserProfile(request: UserProfile): Promise<EmptyResponse> {
    const client = new UserProfileServiceClientImpl(this._rpc);
    return await client.addUserProfile(request);
  }
}
